import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Admin from "../store/ducks/admin.duck";
import * as Reference from "../store/ducks/reference.duck";
import { DataGrid } from "@material-ui/data-grid";
import { Button, Modal, Row, Col, Form, Badge } from "react-bootstrap";
import {
  Paper,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Card,
  Checkbox,
  CardMedia,
  CardActions,
  CardContent,
  Chip,
  Typography,
  makeStyles,
  useMediaQuery,
  IconButton,
  Collapse,
} from "@material-ui/core";
import { BookingWeek } from "./Appointments";
import BookingOutcome from "./BookingOutcome";
import Interweave from "interweave";
import { format } from "date-fns";
import EmailIcon from "@material-ui/icons/Email";
import ToDos from "./ToDos";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Masonry from "react-masonry-css";
import "../../_metronic/_assets/css/app.css";
import "../../_metronic/_assets/css/app2.css";
import { set } from "lodash";

// import medipassSDK from '@medipass/partner-sdk';

const useStyles = makeStyles((theme) => ({
  bookingContainer: {
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  bookingButton: {
    marginLeft: 10,
    paddingLeft: 2,

    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginLeft: 0,
      paddingLeft: 0,
      marginTop: 12,
    },
  },
  noBorder: {
    border: "none",
  },
  media: {
    height: 200,
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

export default function BookingsList(props) {
  // Blob setup for psychologist photos
  const containerName = `psychologists`;
  const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME || "";
  const [showProvider, setShowProvider] = useState(false);

  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 760px)");
  const bookings = useSelector((state) => (props.type === "psychologist" ? state.admin.ProviderBookings : state.admin.Bookings));
  const client = useSelector((state) => state.admin.Client);
  const filters = useSelector((state) => state.admin.Filters);

  const supervisionAreas = useSelector((state) => state.reference.SupervisionAreas).filter((sa) => sa.providertype === "Psychologist");
  const endorsedSupervisionAreas = useSelector((state) => state.reference.SupervisionAreas).filter((sa) => sa.providertype === "Psychologist-Endorsed");

  // const [currentProvider,setCurrentProvider] = useState(props.type==='client' ? client.currentProvider : "[]");
  const [currentBookingPsychologistID, setCurrentBookingPsychologistID] = useState(props.type === "client" ? client.currentpsychologistid : 0);
  const currentClientPaymentType = props.type === "client" ? client.paymentType : 0;
  const currentClientBookingType = props.type === "client" ? (client.appointmenttype === "1" ? "PHONE" : "VIDEO") : "VIDEO";
  const [currentPsychologistFullname, setCurrentPsychologistFullname] = useState(props.type === "client" ? client.psychologistName : 0);
  // const [currentPsychologistID,setCurrentPsychologistID] = useState(props.type==='client' ? client.currentpsychologistid : 0)
  const currentGPID = props.type === "client" ? client.currentgpid : 0;
  const currentGPFullname = props.type === "client" ? client.gpFullName : 0;
  const currentClientID = props.type === "client" ? client.id : 0;
  const currentClientFullname = props.type === "client" ? client.fullname : "";
  const [currentHourlyRate, setCurrentHourlyRate] = useState("TBA");
  const [currentWaitingRoomURL, setCurrentWaitingRoomURL] = useState(props.type === "client" ? client.waitingRoomURL : "");
  const currentGPWaitingRoomURL = props.type === "client" ? client.gpwaitingRoomURL : "";
  const currentClientFirstName = props.type === "client" ? client.firstname : "";
  const currentClientEmail = props.type === "client" ? client.email : "";
  const currentPreferredName = props.type === "client" ? client.preferredName : "";
  const [currentPsychologistTZ, setCurrentPsychologistTZ] = useState("AUS Eastern Standard Time");
  const currentClientTZ = props.type === "client" ? client.timeZone : "";
  const [expanded, setExpanded] = useState(1);
  const currentSpecialistType = props.type === "client" ? client.specialisttype : "";
  const currentProgram = props.type === "client" ? client.programid : "";
  const classes = useStyles();
  const futureBookingStatus = useSelector((state) => state.admin.ClientFutureBookingStatus);
  const filteredBookingsFuture = bookings.filter((booking) => booking.days === "Future");
  const filteredBookingsFutureProvider = bookings.filter(
    (booking) => booking.days === "Future" && (booking.status === "Active" || booking.status === "Attended"),
  );
  const filteredBookingsPast = bookings.filter((booking) => booking.days === "Past");
  const filteredBookingsPastProvider = bookings.filter((booking) => booking.days === "Past" && (booking.status === "Active" || booking.status === "Attended"));
  const psychologists = useSelector((state) => state.admin.Matching);
  const psychologistsNew = psychologists.filter((psy) => psy.nextAvailableNew !== null && psy.nextAvailableNew !== "");
  const psychologistsSupervision = psychologists.filter((psy) => psy.nextAvailableSupervision !== null && psy.nextAvailableSupervision !== "");

  const [cancellationReason, setCancellationReason] = useState();
  const [cancellationTypeSMSText, setCancellationTypeSMSText] = useState("");
  const [cancellationType, setCancellationType] = useState("");
  const [cancellationTypeSMS, setCancellationTypeSMS] = useState(false);

  const [showProviderBio, setShowProviderBio] = useState(false);
  const [providerBioFullName, setProviderBioFullName] = useState();
  const [providerBioBio, setProviderBioBio] = useState();
  var [attendanceStatus, setAttendanceStatus] = useState("");

  // props.type === 'psychologist'
  function handleProviderClose() {
    setShowProvider(false);
  }

  var [providerType, setProviderType] = useState(props.providerType);

  useEffect(() => {
    dispatch(Reference.actions.fetchSupervisionAreas());
  }, [dispatch]);
  useEffect(() => {
    if (!props.id) return;
    dispatch(Admin.actions.fetchBookings({ key: props.type, id: props.id }));
  }, [dispatch, props.type, props.id]);
  // Do not return matching information for Centralised Service bookings if using the client portal
  // console.log("Props:", props);
  useEffect(() => {
    dispatch(
      Admin.actions.fetchMatching({
        providertype: providerType,
        invite: true,
        availabilitytype:
          props.view === "dashboard" && props.centralisedService === "1"
            ? "CentralisedService"
            : props.view === "dashboard" && props.type === "Client"
              ? "New"
              : "Both",
      }),
    );
  }, [dispatch, providerType]);
  // useEffect( () => { dispatch(Admin.actions.fetchMatching( { providertype : 'Psychologist', invite : true, availabilitytype : props.paymentType === 'NDIS' || props.paymentType === 'EAP' || props.paymentType === 'Contract' ? 'NDIS/Contract/EAP' : 'Both' })) }, [dispatch] )
  useEffect(() => {
    // console.log('Running UseEffect')
    if (props.type === "client") {
      // console.log('Calling Dispatch')
      dispatch(
        Admin.actions.fetchClientFutureBookingStatus({
          providertype: providerType,
        }),
      );
    }
  }, [dispatch, props.type, client, providerType]);

  var [showBooking, setShowBooking] = useState(false);
  var [showCancelBooking, setShowCancelBooking] = useState(false);
  const [toggleCancelMessage, setToogleCancelMessage] = useState(false);
  const [showCancelProviderBooking, setShowCancelProviderBooking] = useState(false);
  const [showCancelAdminBooking, setShowCancelAdminBooking] = useState(false);
  const [showAttendanceDialog, setShowAttendanceDialog] = useState(false);
  var [booking, setBooking] = useState(false);
  var [toggleMessage, setToggleMessage] = useState(false);
  var [newNote, setNewNote] = useState("");
  var [sentMsg, setSentMsg] = useState();
  var [makeBooking, setMakeBooking] = useState(false);

  const [showToDo, setShowToDo] = useState(false);
  const [toDoClientID, setToDoClientID] = useState();
  const [toDoTitle, setToDoTitle] = useState("");

  const [sessionTypeChangeBookingID, setSessionTypeChangeBookingID] = useState(0);
  const [sessionTypeChangeSessionType, setSessionTypeChangeSessionType] = useState("");
  const [sessionTypeChangeProviderType, setSessionTypeChangeProviderType] = useState("Psychologist");
  const [showSessionTypeChange, setShowSessionTypeChange] = useState(false);

  const [bookingLocationChangeBookingID, setBookingLocationChangeBookingID] = useState(0);
  const [bookingLocationChangeBookingLocation, setBookingLocationChangeBookingLocation] = useState("");
  const [bookingLocationChangeProviderType, setBookingLocationChangeProviderType] = useState("Psychologist");
  const [showBookingLocationChange, setShowBookingLocationChange] = useState(false);

  const loadToDos = (clientID, fullName) => {
    setToDoClientID(clientID);
    setToDoTitle(fullName);
    setShowToDo(true);
  };

  const handleExpandClick = (id) => {
    if (id === expanded) {
      setExpanded(0);
    } else {
      setExpanded(id);
    }
  };

  const moreProviderBio = (fullName, bio) => {
    // console.log('Read More Clicked')
    setProviderBioFullName(fullName);
    setProviderBioBio(bio);
    setShowProviderBio(true);
  };

  const clientCancel = (thisBooking) => {
    // Load data
    setBooking(thisBooking);
    // Check if in Admin portal - no rules apply
    if (props.view !== "admin") {
      // Clients cannot cancel bookings with 48 hours
      var notice48 = new Date();
      var noticePast = new Date();
      var clientDate = new Date(thisBooking.clientDate);
      notice48.setDate(notice48.getDate() + 2);
      // Check if the booking is in the next 48 hours
      if (clientDate < notice48 && clientDate > noticePast) {
        // console.log('Within48');
        setToogleCancelMessage(true);
      }
    }
    //
    // Open Modal
    setShowCancelBooking(true);
  };

  const updateBookingLocation = (thisBooking) => {
    // Set data
    setBookingLocationChangeBookingID(thisBooking.id);
    setBookingLocationChangeBookingLocation(thisBooking.bookingLocation);
    setBookingLocationChangeProviderType(thisBooking.providerType);
    // Open Modal
    setShowBookingLocationChange(true);
  };

  const updateSessionType = (thisBooking) => {
    // Set data
    setSessionTypeChangeBookingID(thisBooking.id);
    setSessionTypeChangeSessionType(thisBooking.bookingCode);
    setSessionTypeChangeProviderType(thisBooking.providerType);
    // Open Modal
    setShowSessionTypeChange(true);
  };
  const providerCancel = (thisBooking) => {
    // Load data
    setBooking(thisBooking);
    // Close current modal
    setShowBooking(false);
    if (props.specialistType === "centralisedservice") {
      setShowAttendanceDialog(true);
      setAttendanceStatus(filters.bookingPhase === "Future" ? "Upcoming" : "Past");
    } else {
      // Open Provider Cancel Modal
      setShowCancelProviderBooking(true);
    }
  };

  const adminCancel = (thisBooking) => {
    // Load data
    setBooking(thisBooking);
    // Close current modal
    setShowBooking(false);
    if (props.specialistType === "centralisedservice") {
      setAttendanceStatus(filters.bookingPhase === "Future" ? "Upcoming" : "Past");
      setShowAttendanceDialog(true);
    } else {
      // Open Admin Cancel Modal
      setShowCancelAdminBooking(true);
    }
  };

  const providerVerbalConsent = (thisBooking) => {
    // Close Consent Form and Update Comment to Verbal Consent
    dispatch(
      Admin.actions.putAppointmentConsent({
        id: thisBooking.id,
        refreshPayload: { key: props.type, id: props.id },
      }),
    );
  };

  const providerResendConsent = (thisBooking) => {
    // Resent Consent Form to Client (if new) or if past close new and send past
    dispatch(
      Admin.actions.sendBulkBillingConsentForm({
        id: thisBooking.id,
        days: thisBooking.days,
        refreshPayload: { key: props.type, id: props.id },
      }),
    );
  };

  const handleSessionTypeChangeClose = () => {
    setShowSessionTypeChange(false);
  };

  const handleBookingLocationChangeClose = () => {
    setShowBookingLocationChange(false);
  };

  const handleSessionTypeChange = () => {
    // Update Session Type of Booking and nothing else
    dispatch(
      Admin.actions.putAppointmentSessionType({
        id: sessionTypeChangeBookingID,
        bookingCode: sessionTypeChangeSessionType,
        refreshPayload: { key: props.type, id: props.id },
      }),
    );
    // Close Modal
    setShowSessionTypeChange(false);
  };

  const handleBookingLocationChange = () => {
    // Update Booking Location of Booking and nothing else
    dispatch(
      Admin.actions.putAppointmentBookingLocation({
        id: bookingLocationChangeBookingID,
        bookingLocation: bookingLocationChangeBookingLocation,
        refreshPayload: { key: props.type, id: props.id },
      }),
    );
    // Close Modal
    setShowBookingLocationChange(false);
  };

  const loadBooking = (thisBooking) => {
    setBooking(thisBooking);
    setCancellationTypeSMSText(
      `Hello ${thisBooking && thisBooking.clientPreferredName && thisBooking.clientPreferredName.length > 0 ? thisBooking.clientPreferredName : thisBooking.clientFirstName}, We notice you did not attend your appointment with Rural Health Connect. We hope everything is OK. If you would like to discuss or reschedule please call us on 0493201005 or 0493432144 or your provider directly.`,
    );
    var newishNote = `Dear ${thisBooking && thisBooking.clientPreferredName && thisBooking.clientPreferredName.length > 0 ? thisBooking.clientPreferredName : thisBooking.clientFirstName},

Please note you have been booked for a consultation with ${thisBooking.psychologistfullname} at ${format(new Date(thisBooking.clientDate ? thisBooking.clientDate : null), "dd-MM-yyyy hh:mm aa")}. `;

    if (!thisBooking.bookingType) {
      if (thisBooking.appointmenttype === "1") {
        setNewNote(`${newishNote}   
    ${thisBooking.psychologistfullname} will call you.`);
      } else {
        setNewNote(`${newishNote}
    Please connect here: ${thisBooking.waitingroomurl} at that time.`);
      }
    } else {
      if (thisBooking.bookingType === "PHONE") {
        setNewNote(`${newishNote}   
          ${thisBooking.psychologistfullname} will call you.`);
      } else {
        if (thisBooking.bookingType === "VIDEO") {
          setNewNote(`${newishNote}
            Please connect here: ${thisBooking.waitingroomurl} at that time.`);
        } else {
          setNewNote(`${newishNote}
            Please attend here: ${thisBooking.fullAddress} at that time.`);
        }
      }
    }

    setToggleMessage(false);
    setShowBooking(true);
  };

  var cols = [
    {
      field: "id",
      headerName: "ID",
      hide: props.view === "dashboard" && props.centralisedService === "1",
      flex: 0.5,
    },
    {
      field: "psychologistDate",
      type: "date",
      headerName: "Date",
      flex: 0.7,
      renderCell: (params) => format(new Date(params.value ? params.value : null), "dd-MM-yyyy"),
    },
  ];

  if (props.type === "psychologist") {
    cols.push({
      field: "clientDate",
      type: "date",
      headerName: "My Time / Client Time",
      flex: 0.7,
      renderCell: (params) =>
        format(new Date(params.row.psychologistDate), "h:mm aa") +
        (params.row.clientDate !== params.row.psychologistDate ? " / " + format(new Date(params.row.clientDate), "h:mm aa") : ""),
    });
  }

  if (props.type === "client") {
    cols.push({
      field: "clientDate",
      type: "date",
      headerName: "Time",
      flex: 0.7,
      renderCell: (params) => format(new Date(params.row.clientDate), "h:mm aa"),
    });
  }

  if (props.type === "psychologist") {
    cols.push({
      field: "bookingCount",
      headerName: "Bookings Count",
      flex: 0.7,
    });
  }

  if (props.type === "psychologist") {
    cols.push({
      field: "bulkBillingFormStatus",
      headerName: "Consent",
      flex: 0.7,
      renderCell: (params) => (params.row.paymentType === "Bulk Billed" ? params.value : ""),
    });
  }

  if (props.type !== "psychologist") {
    cols.push({ field: "title", headerName: "Provider", flex: 0.7 });
  } else {
    cols.push({
      field: "title",
      headerName: "Client",
      flex: 1,
      renderCell: (params) => {
        return (
          <Grid container justifyContent="space-between">
            <Grid item>{params.value}</Grid>
            {params.row.toDoCount !== 0 ? (
              <>
                <Grid item>
                  <EmailIcon style={{ marginLeft: 8, color: "green" }} onClick={() => loadToDos(params.row.clientID, params.value)} />
                </Grid>
              </>
            ) : null}
          </Grid>
        );
      },
    });
  }

  if (props.view === "admin" && props.specialistType !== "centralisedservice") {
    cols.push({ field: "charged", headerName: "Charged", flex: 0.7 });
  }

  if (props.view === "admin") {
    cols.push({ field: "status", headerName: "Status", flex: 0.7 });
  }

  if (props.specialistType === "centralisedservice") {
    cols.push({
      field: "bookingCodeDescription",
      headerName: "Session Type",
      flex: 1.4,
      renderCell: (params) => {
        return (
          <Grid container justifyContent="space-between">
            <Grid item onClick={() => updateSessionType(params.row)} className="cell-Link">
              <strong>{params.value}</strong>
            </Grid>
          </Grid>
        );
      },
    });
  }

  if (props.specialistType === "centralisedservice") {
    cols.push({
      field: "bookingLocation",
      headerName: "Location",
      flex: 0.7,
      renderCell: (params) => {
        return (
          <Grid container justifyContent="space-between">
            <Grid item onClick={() => updateBookingLocation(params.row)} className="cell-Link">
              <strong>{params.value}</strong>
            </Grid>
          </Grid>
        );
      },
    });
  }

  if (props.type === "psychologist" && props.medipassapikey === "Configured") {
    cols.push(
      {
        field: "invoicedate",
        type: "date",
        headerName: "Invoice Date",
        flex: 1,
      },
      { field: "invoicestatus", headerName: "Invoice Status", flex: 0.7 },
    );
  }

  cols.push({
    field: "action",
    headerName: "Actions",
    flex: 1.5, //width: 100
    renderCell: (params) => (
      <>
        <Button
          variant="secondary"
          size="sm"
          style={{
            color: "black",
            fontWeight: 500,
            border: 0,
            background: "#eee",
            marginRight: 10,
          }}
          onClick={() => loadBooking(bookings.find((r) => r.id === params.row.id))}
        >
          View
        </Button>
        {props.type === "psychologist" &&
        params.row.status !== "Cancelled" &&
        props.autoBulkBillingConsentForm === "Y" &&
        params.row.status !== "LateCancel" &&
        params.row.status !== "LateCancelProvider" &&
        props.specialistType !== "centralisedservice" &&
        props.view === "psychologist" &&
        params.row.paymentType === "Bulk Billed" &&
        params.row.bulkBillingFormStatus !== "Completed" &&
        params.row.bulkBillingFormStatus !== "Verbal Consent Given" ? (
          <>
            <Button variant="success" style={{ marginRight: 10 }} size="sm" onClick={() => providerVerbalConsent(bookings.find((r) => r.id === params.row.id))}>
              Verbal Consent
            </Button>
            <Button variant="warning" style={{ marginRight: 10 }} size="sm" onClick={() => providerResendConsent(bookings.find((r) => r.id === params.row.id))}>
              Resend Consent
            </Button>
          </>
        ) : null}
        {props.type === "client" &&
        params.row.status !== "Cancelled" &&
        params.row.status !== "LateCancel" &&
        params.row.status !== "LateCancelProvider" &&
        filters.bookingPhase !== "Past" &&
        props.specialistType !== "centralisedservice" ? (
          <>
            {props.view === "psychologist" ? (
              <>
                <Button variant="warning" style={{ marginRight: 10 }} size="sm" onClick={() => providerCancel(bookings.find((r) => r.id === params.row.id))}>
                  Cancel Booking
                </Button>
              </>
            ) : (
              <>
                {props.view === "admin" ? (
                  <Button variant="warning" style={{ marginRight: 10 }} size="sm" onClick={() => adminCancel(bookings.find((r) => r.id === params.row.id))}>
                    Cancel Booking
                  </Button>
                ) : (
                  <Button
                    variant="warning"
                    size="sm"
                    style={{
                      color: "white",
                      fontWeight: 500,
                      border: 0,
                      background: "#A33383",
                      marginRight: 10,
                    }}
                    onClick={() => clientCancel(bookings.find((r) => r.id === params.row.id))}
                  >
                    Cancel Booking
                  </Button>
                )}
              </>
            )}
          </>
        ) : null}
        {props.type === "client" &&
        params.row.status !== "Cancelled" &&
        params.row.status !== "LateCancel" &&
        params.row.status !== "LateCancelProvider" &&
        props.specialistType === "centralisedservice" ? (
          <>
            {props.view === "psychologist" ? (
              <Button variant="warning" size="sm" onClick={() => providerCancel(bookings.find((r) => r.id === params.row.id))}>
                {filters.bookingPhase === "Past" ? "Mark Attendance" : "Cancel Booking"}
              </Button>
            ) : (
              <>
                {props.view === "admin" ? (
                  <Button variant="warning" size="sm" onClick={() => adminCancel(bookings.find((r) => r.id === params.row.id))}>
                    Cancel Booking
                  </Button>
                ) : null}
              </>
            )}
          </>
        ) : null}
      </>
    ),
  });

  function getActionButtons(id) {
    if (props.view === "psychologist") {
      return (
        <>
          <Button variant="warning" size="sm" onClick={() => providerCancel(bookings.find((r) => r.id === id))}>
            Cancel Booking
          </Button>
        </>
      );
    } else {
      return null;
    }
  }

  function updateCancellationTypeSMS(value) {
    setCancellationTypeSMS(value);
  }

  function cancelBooking(id) {
    // Need to handle no show which is triggered if it is save by a provider and reason is not selected - it is like the multiverse
    if (props.view === "psychologist" || props.view === "admin") {
      if (cancellationType === "NoShow") {
        // Update database as client did not show
        dispatch(
          Admin.actions.putAppointment({
            id: id,
            status: "NoShow",
            cancellationReason: cancellationReason,
            refreshPayload: { key: props.type, id: props.id },
          }),
        );
        // Update local display
        setBooking({ ...booking, status: "NoShow" });
        if (cancellationTypeSMS && cancellationTypeSMSText && cancellationTypeSMSText.length > 10) {
          const formData = new FormData();
          formData.append("type", "Client");
          formData.append("pkid", booking.clientID);
          formData.append("subject", "");
          formData.append("selector", "SMS");
          formData.append("note", cancellationTypeSMSText);
          formData.append("faxdestination", "");
          formData.append("faxFile", "");
          formData.append("sendFormID", 0);
          // Ok Time to Dispatch
          process.env.REACT_APP_DEBUG && console.log(...formData);
          dispatch(
            Admin.actions.postNote({
              formData: formData,
              refreshPayload: { key: props.type, id: props.id },
            }),
          );
        }
      } else {
        if (cancellationType === "LateCancel") {
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "LateCancel",
              cancellationReason: cancellationReason,
              refreshPayload: { key: props.type, id: props.id },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "LateCancel" });
        } else {
          if (cancellationType === "LateCancelProvider") {
            dispatch(
              Admin.actions.putAppointment({
                id: id,
                status: "LateCancelProvider",
                cancellationReason: cancellationReason,
                refreshPayload: { key: props.type, id: props.id },
              }),
            );
            // Update local display
            setBooking({ ...booking, status: "LateCancelProvider" });
          } else {
            // Update database as booking cancelled by provider
            dispatch(
              Admin.actions.putAppointment({
                id: id,
                status: "Cancelled",
                cancellationReason: cancellationReason,
                refreshPayload: { key: props.type, id: props.id },
              }),
            );
            // Update local display
            setBooking({ ...booking, status: "Cancelled" });
          }
        }
      }
    } else {
      if (cancellationType === "LateCancel") {
        dispatch(
          Admin.actions.putAppointment({
            id: id,
            status: "LateCancel",
            cancellationReason: cancellationReason,
            refreshPayload: { key: props.type, id: props.id },
          }),
        );
        // Update local display
        setBooking({ ...booking, status: "LateCancel" });
      } else {
        if (cancellationType === "LateCancelProvider") {
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "LateCancelProvider",
              cancellationReason: cancellationReason,
              refreshPayload: { key: props.type, id: props.id },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "LateCancelProvider" });
        } else {
          // Update database
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "Cancelled",
              refreshPayload: { key: props.type, id: props.id },
              note: cancellationReason,
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "Cancelled" });
        }
      }
    }
    // Close provider booking cancel modal - if open
    setShowCancelProviderBooking(false);
    setShowCancelBooking(false);
    setShowCancelAdminBooking(false);
  }

  // function deleteBooking(id) {
  //   dispatch(Admin.actions.putAppointment(
  //     { id: id,
  //       status: 'Deleted',
  //       refreshPayload: { key: props.type, id: props.id }
  //     }));
  //   setBooking({...booking, status: 'Deleted'});
  //   setShowBooking(false)
  // }

  // function noshowBooking(id) {
  //   dispatch(Admin.actions.putAppointment(
  //     { id: id,
  //       status: 'NoShow',
  //       refreshPayload: { key: props.type, id: props.id }
  //     }));
  //   setBooking({...booking, status: 'NoShow'});
  //   setShowBooking(false)
  // }

  function sendMessage() {
    const formData = new FormData();
    // Add fields
    formData.append("type", "Client");
    formData.append("pkid", booking.clientID);
    formData.append("subject", "");
    formData.append("selector", "SMS");
    formData.append("note", newNote);
    formData.append("faxdestination", "");
    formData.append("faxFile", "");
    formData.append("sendFormID", 0);
    // Ok Time to Dispatch
    process.env.REACT_APP_DEBUG && console.log(...formData);
    dispatch(
      Admin.actions.postNote({
        formData: formData,
        type: props.type,
        pkID: props.pkid,
      }),
    );
    setSentMsg("Message sent!");
    showMessageTimer();
  }

  const showMessageTimer = () => {
    const timer = setTimeout(() => {
      setSentMsg(undefined);
      setShowBooking(false);
    }, 3000);
    return () => clearTimeout(timer);
  };

  function createBooking(type) {
    setProviderType(type);
    setMakeBooking(true);
  }

  function selectProvider(row) {
    // Update State with newly chosen psychologist
    setCurrentBookingPsychologistID(row.id);
    setCurrentPsychologistFullname(row.fullname);
    setCurrentHourlyRate(row.hourlyrate);
    setCurrentWaitingRoomURL(row.waitingroomurl);
    setCurrentPsychologistTZ(row.timezone);
    // Update Client
    dispatch(
      Admin.actions.putClientPsychologist({
        psychologistid: row.id,
        clientid: currentClientID,
        providerName: row.fullname,
      }),
    );
    // Now ask client to make new booking
    setProviderType("Psychologst");
    if (props.paymentType === "Supervision" || props.providerType === "Supervision") {
      setProviderType("Supervision");
    }
    setShowProvider(false);
    setMakeBooking(true);
  }

  function NewBookingButton() {
    // Changed this to show the book new appointment button on client dashboard - may need to change it back - 16/11/22
    // if (props.type !== 'client' || props.view !== 'client')
    // console.log(props);
    if (props.type !== "client" || props.centralisedService === "1") {
      return null;
    }
    return (
      <>
        {props.currentpsychologistid && props.currentpsychologistid > 0 ? (
          <>
            {providerType === "Financial" ? (
              <Grid item className={classes.bookingButton}>
                <Button variant="primary" size="sm" onClick={() => createBooking("Financial")}>
                  Book Financial Counsellor Appointment
                </Button>
              </Grid>
            ) : (
              <>
                {providerType === "Supervision" ? (
                  <>
                    <Grid item className={classes.bookingButton}>
                      <Button variant="primary" size="sm" onClick={() => createBooking("Supervision")}>
                        Book Supervision Appointment
                      </Button>
                    </Grid>
                    {!futureBookingStatus ? (
                      <Grid item className={classes.bookingButton}>
                        <Button variant="primary" size="sm" onClick={() => setShowProvider(true)}>
                          Select Different Supervisor
                        </Button>
                      </Grid>
                    ) : null}
                  </>
                ) : (
                  <>
                    <Grid item className={classes.bookingButton}>
                      <Button variant="primary" size="sm" onClick={() => createBooking("Psychologist")}>
                        Book Psychologist Appointment
                      </Button>
                    </Grid>
                    {!futureBookingStatus ? (
                      <>
                        {props.nthqldphn !== "1" ? (
                          <Grid item className={classes.bookingButton}>
                            <Button variant="primary" size="sm" onClick={() => setShowProvider(true)}>
                              Select Different Psychologist
                            </Button>
                          </Grid>
                        ) : (
                          <>
                            <Grid item className={classes.bookingButton}>
                              <Typography
                                variant="body2"
                                style={{
                                  marginTop: 10,
                                  marginBottom: 10,
                                  fontStyle: "bold",
                                }}
                              >
                                If you wish to change providers please call us on 0490 855 396
                              </Typography>
                            </Grid>
                          </>
                        )}
                      </>
                    ) : null}
                  </>
                )}
              </>
            )}
          </>
        ) : null}
        {props.currentgpid ? (
          <Grid item className={classes.bookingButton}>
            <Button variant="primary" size="sm" onClick={() => createBooking("GP")}>
              Book GP Appointment
            </Button>
          </Grid>
        ) : null}
      </>
    );
  }

  function BookingData() {
    let selectedList;
    if (filters.bookingPhase === "Future") {
      // Don't display non active bookings to psychologists
      if (props.type === "psychologist") {
        selectedList = filteredBookingsFutureProvider;
      } else {
        selectedList = filteredBookingsFuture;
      }
    } else {
      // Don't display non active bookings to psychologists
      if (props.type === "psychologist") {
        selectedList = filteredBookingsPastProvider;
      } else {
        selectedList = filteredBookingsPast;
      }
    }
    // console.log(props.view)
    // console.log(props.type)
    return (
      <>
        {bookings ? (
          props.nextBooking ? (
            <Button variant="primary" size="sm" onClick={() => loadBooking(bookings.find((r) => r.id === props.nextBooking.id))}>
              View
            </Button>
          ) : (
            <>
              <Paper>
                <Grid container justifyContent="space-between" style={{ padding: 10 }}>
                  <Grid item style={{ marginTop: 2, marginLeft: 2 }}>
                    <Grid container className={classes.bookingContainer}>
                      <Grid item style={{ marginLeft: 10 }}>
                        <FormControl variant="outlined" className={classes.formControl}>
                          <Select
                            labelId="bookingPhase-label"
                            id="bookingPhase"
                            margin="dense"
                            style={{
                              minWidth: 120,
                              backgroundColor: "#ffffff",
                            }}
                            value={filters.bookingPhase}
                            onChange={(event) =>
                              dispatch(
                                Admin.actions.setFilters({
                                  filterName: "bookingPhase",
                                  filterValue: event.target.value,
                                }),
                              )
                            }
                          >
                            <MenuItem key={1} value="Future">
                              Future
                            </MenuItem>
                            <MenuItem key={2} value="Past">
                              Past
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <NewBookingButton />
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
              {props.view !== "dashboard" ? (
                <Paper style={{ height: 660 }}>
                  <DataGrid
                    rows={selectedList}
                    columns={cols}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    checkboxSelection={false}
                    sortModel={[{ field: "psychologistDate", sort: "asc" }]}
                  />
                </Paper>
              ) : (
                <Paper
                  style={{
                    height: props.centralisedService === "1" ? 660 : 200,
                  }}
                >
                  <DataGrid
                    rows={selectedList}
                    columns={cols}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    checkboxSelection={false}
                    sortModel={[{ field: "psychologistDate", sort: "asc" }]}
                  />
                </Paper>
              )}
            </>
          )
        ) : (
          "None"
        )}
      </>
    );
  }

  // note that next booking prop renders the next booking button to provide all booking actions when used on a dashboard. Otherwise we return the list.
  return (
    <>
      {makeBooking ? (
        <BookingWeek
          mode="client"
          inviteType={props.type}
          gpID={currentGPID}
          gpFullname={currentGPFullname}
          psychologistID={currentBookingPsychologistID}
          psychologistFullname={currentPsychologistFullname}
          clientID={currentClientID}
          clientFullname={currentClientFullname}
          currentHourlyRate={currentHourlyRate}
          currentWaitingRoomURL={currentWaitingRoomURL}
          gpcurrentWaitingRoomURL={currentGPWaitingRoomURL}
          clientFirstName={currentClientFirstName}
          clientPreferredName={currentPreferredName}
          clientEmail={currentClientEmail}
          psychologistTZ={currentPsychologistTZ}
          clientTZ={currentClientTZ}
          paymentType={currentClientPaymentType}
          bookingType={currentClientBookingType}
          setMakeBooking={setMakeBooking}
          providerType={providerType}
          specialistType={currentSpecialistType}
          program={currentProgram}
        />
      ) : (
        <>
          <BookingData />
          <Modal show={showBooking} onHide={() => setShowBooking(false)} dialogClassName="new-bookingDialog-modal" centered>
            <Modal.Header closeButton className="new-booking-modal">
              <Modal.Title>Booking - {booking.status}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
              {!toggleMessage ? (
                <Grid container spacing={3} style={{ height: 247 }}>
                  <Grid item md={3} xs={6}>
                    {props.providerType === "GP" ? <>GP:</> : <>{props.providerType === "Financial" ? <>Financial Counsellor:</> : <>Psychologist:</>}</>}
                  </Grid>
                  <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                    {booking.psychologistfullname}
                  </Grid>
                  <Grid item md={3} xs={6}>
                    Client:
                  </Grid>
                  <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                    {booking.clientfullname}
                  </Grid>
                  <Grid item md={3} xs={6}>
                    Date:
                  </Grid>
                  <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                    {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "dd-MM-yyyy")}
                  </Grid>
                  <Grid item md={3} xs={6}>
                    Time:
                  </Grid>
                  <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                    {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "h:mm aa")}
                  </Grid>
                  <Grid item md={3} xs={6}>
                    Booking Type:
                  </Grid>
                  <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                    {booking.bookingType && booking.bookingType === "FACE" ? "Face to Face" : "Video"}
                  </Grid>
                  {booking.clientDate !== booking.psychologistDate ? (
                    <>
                      <Grid item md={3} xs={6}>
                        Client's Time:
                      </Grid>
                      <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                        {format(new Date(booking.clientDate ? booking.clientDate : null), "h:mm aa")}
                      </Grid>
                    </>
                  ) : null}
                  <Grid item md={3} xs={6}>
                    Session Type:
                  </Grid>
                  <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                    {booking.bookingCodeDescription}
                  </Grid>
                  {/* <Grid item md={3} xs={6}>
                    Session URL:
                  </Grid>
                  <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                    <a href={booking.waitingroomurl} target="_blank" rel="noopener noreferrer">
                      {booking.waitingroomurl}
                    </a>
                  </Grid> */}
                </Grid>
              ) : sentMsg ? (
                <>
                  <Row>
                    <Col md="12" style={{ height: 222 }}>
                      {sentMsg}
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={8}
                          type="text"
                          name="psychologistNote"
                          defaultValue={newNote}
                          onBlur={(event) => setNewNote(event.target.value)}
                          autoComplete="new-password"
                          style={{ borderColor: "#D1D1D1" }}
                        />
                        {/* {newNoteHelpText.length ? (<p className='error-help'>{newNoteHelpText}</p>) : ''} */}
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              )}
            </Modal.Body>
            <Modal.Footer className="new-booking-modal">
              <Grid container direction="row" justifyContent="space-between" alignItems="center">
                {!toggleMessage ? (
                  <>
                    <Grid item>{getActionButtons(booking.id)}</Grid>
                    <Grid item>
                      {props.type === "psychologist" ? (
                        <Button variant="primary" size="sm" onClick={() => setToggleMessage(!toggleMessage)} style={{ marginRight: 15 }}>
                          Message
                        </Button>
                      ) : null}
                      <Button variant="secondary" size="sm" onClick={() => setShowBooking(false)} className="lightButtonOutlinedLarge">
                        Close
                      </Button>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item>
                      <Button variant="secondary" size="sm" onClick={() => setToggleMessage(!toggleMessage)} className="lightButtonOutlinedLarge">
                        Cancel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button variant="success" size="sm" onClick={() => sendMessage()}>
                        Send &gt;
                      </Button>
                    </Grid>
                  </>
                )}
              </Grid>
            </Modal.Footer>
          </Modal>
        </>
      )}

      <Modal show={showCancelBooking} onHide={() => setShowCancelBooking(false)} dialogClassName="new-bookingDialog-modal" centered>
        <Modal.Header closeButton className="new-booking-modal">
          <Modal.Title>
            Cancel your booking on {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "dd-MM-yyyy")} at{" "}
            {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "h:mm aa")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          {!toggleCancelMessage ? (
            <Grid container spacing={3} style={{ height: 150 }}>
              <Grid item md={6} xs={6}>
                {props.providerType === "GP" ? (
                  <>With GP:</>
                ) : (
                  <>{props.providerType === "Financial" ? <>With Financial Counsellor:</> : <>With Psychologist:</>}</>
                )}
              </Grid>
              <Grid item md={6} xs={6} style={{ fontWeight: 600 }}>
                {booking.psychologistfullname}
              </Grid>
              <Grid item md={6} xs={6}>
                Date:
              </Grid>
              <Grid item md={6} xs={6} style={{ fontWeight: 600 }}>
                {format(new Date(booking.clientDate ? booking.psychologistDate : null), "dd-MM-yyyy")}
              </Grid>
              <Grid item md={6} xs={6}>
                Time:
              </Grid>
              <Grid item md={6} xs={6} style={{ fontWeight: 600 }}>
                {format(new Date(booking.clientDate ? booking.psychologistDate : null), "h:mm aa")}
              </Grid>
            </Grid>
          ) : (
            <>
              <Row>
                <Col md="12" style={{ height: 222, fontWeight: 600 }}>
                  <p>
                    You are trying to alter a booking within the 48 hour window. This may incur fees. Please message your provider via the Send Message to your
                    Provider Button.
                  </p>
                  {/* <p>Please call 0427 692 377 for assistance.</p>                  */}
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="new-booking-modal">
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <Button variant="secondary" size="sm" onClick={() => setShowCancelBooking(false)} className="lightButtonOutlinedLarge">
                Close
              </Button>
            </Grid>
            {!toggleCancelMessage ? (
              <>
                <Grid item>
                  <Button variant="warning" size="sm" onClick={() => cancelBooking(booking.id)}>
                    Cancel Booking &gt;
                  </Button>
                </Grid>
              </>
            ) : null}
          </Grid>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAttendanceDialog}
        onHide={() => setShowAttendanceDialog(false)}
        size="lg" // "sm" | "lg" | "xl"
        dialogClassName="note-modal"
        style={{ zIndex: 1150 }}
        centered
      >
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>Booking with {booking && booking.clientfullname ? booking.clientfullname : ""}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <BookingOutcome
            name={booking && booking.clientfullname ? booking.clientfullname : ""}
            start={booking && booking.psychologistDate ? booking.psychologistDate : null}
            status={booking && booking.status ? booking.status : ""}
            clientID={booking && booking.clientID ? booking.clientID : null}
            bookingID={booking && booking.id ? booking.id : null}
            paymentType={booking && booking.paymentType ? booking.paymentType : ""}
            psychologistID={booking && booking.psychologistID ? booking.psychologistID : null}
            closeModal={setShowAttendanceDialog}
            attendanceStatus={attendanceStatus}
            source="List"
          />
        </Modal.Body>
      </Modal>

      <Modal show={showCancelProviderBooking} onHide={() => setShowCancelProviderBooking(false)} dialogClassName="new-bookingDialog-modal" centered>
        <Modal.Header closeButton className="new-booking-modal">
          <Modal.Title>Booking with {booking.clientfullname}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <Grid container spacing={3}>
            <Grid item md={3} xs={6}>
              Client:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {booking.clientfullname}
            </Grid>
            <Grid item md={3} xs={6}>
              Date:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "dd-MM-yyyy")}
            </Grid>
            <Grid item md={3} xs={6}>
              Time:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "h:mm aa")}
            </Grid>
            {booking.clientDate !== booking.psychologistDate ? (
              <>
                <Grid item md={3} xs={6}>
                  Client's Time:
                </Grid>
                <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                  {format(new Date(booking.clientDate ? booking.clientDate : null), "h:mm aa")}
                </Grid>
              </>
            ) : null}
            {/* <Grid item md={3} xs={6}>
              Session URL:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              <a href={booking.waitingroomurl} target="_blank" rel="noopener noreferrer">
                {booking.waitingroomurl}
              </a>
            </Grid> */}
            <hr />
            <Grid item md={12} xs={6}>
              <Form.Group>
                <Form.Label style={{ fontWeight: 600, paddingBottom: 10 }}>Why is this booking being cancelled?</Form.Label>
                <Form.Check id="cancellationType-NoShow" name="noShowCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="NoShow"
                    type="radio"
                    checked={cancellationType === "NoShow" ? true : false}
                    onChange={(e) => setCancellationType("NoShow")}
                  />
                  <Form.Check.Label style={{ marginLeft: 12 }}>Client did not attend </Form.Check.Label>
                </Form.Check>
                <Form.Check id="cancellationType-LateCancel" name="LateCancelCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="LateCancel"
                    type="radio"
                    checked={cancellationType === "LateCancel" ? true : false}
                    onChange={(e) => setCancellationType("LateCancel")}
                  />
                  <Form.Check.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Client </Form.Check.Label>
                </Form.Check>
                <Form.Check id="cancellationType-Provider24" name="providerCancellation24" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="providerCancellation24"
                    type="radio"
                    checked={cancellationType === "LateCancelProvider" ? true : false}
                    onChange={(e) => setCancellationType("LateCancelProvider")}
                  />
                  <Form.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Provider</Form.Label>
                </Form.Check>
                <Form.Check id="cancellationType-Provider" name="providerCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="providerCancellationr"
                    type="radio"
                    checked={cancellationType === "Provider" ? true : false}
                    onChange={(e) => setCancellationType("Provider")}
                  />
                  <Form.Label style={{ marginLeft: 12 }}>Cancelled</Form.Label>
                </Form.Check>
                {cancellationType !== "" ? (
                  <>
                    {cancellationType === "NoShow" ? (
                      <Form.Label style={{ marginLeft: 12 }}>To cancel please enter information relating to the Client not attending</Form.Label>
                    ) : (
                      <Form.Label style={{ marginLeft: 12 }}>To cancel please enter the reason for cancellation</Form.Label>
                    )}
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="cancellationReason"
                      value={cancellationReason}
                      onBlur={(e) => setCancellationReason(e.target.value)}
                      autoComplete="new-password"
                    />
                    {cancellationType === "NoShow" ? (
                      <>
                        <Checkbox
                          aria-label="Send Cancellation SMS"
                          name="cancellationSMS"
                          value={cancellationTypeSMS}
                          onChange={(event) => updateCancellationTypeSMS(event.target.checked)}
                          style={{ paddingTop: 6, paddingLeft: 0 }}
                        />
                        <Form.Label style={{ marginLeft: 12 }}>Do you want to SMS the Client not attending</Form.Label>
                      </>
                    ) : null}
                    {cancellationTypeSMS ? (
                      <>
                        <Form.Label style={{ marginLeft: 12 }}>Please enter the SMS message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          name="cancellationTypeSMSText"
                          value={cancellationTypeSMSText}
                          onChange={(event) => setCancellationTypeSMSText(event.target.value)}
                          autoComplete="new-password"
                        />
                      </>
                    ) : null}
                  </>
                ) : null}
              </Form.Group>
            </Grid>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="new-booking-modal">
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <Button variant="secondary" size="sm" onClick={() => setShowCancelProviderBooking(false)} className="lightButtonOutlinedLarge">
                Close
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="warning"
                size="sm"
                onClick={() => cancelBooking(booking.id)}
                disabled={!cancellationReason || (cancellationReason && cancellationReason.replace(/\s/g, "").length < 5)}
                className="lightButtonOutlinedLarge"
              >
                Cancel Booking &gt;
              </Button>
            </Grid>
          </Grid>
        </Modal.Footer>
      </Modal>

      <Modal show={showCancelAdminBooking} onHide={() => setShowCancelAdminBooking(false)} dialogClassName="new-bookingDialog-modal" centered>
        <Modal.Header closeButton className="new-booking-modal">
          <Modal.Title>Booking with {booking.clientfullname}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <Grid container spacing={3}>
            <Grid item md={3} xs={6}>
              Client:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {booking.clientfullname}
            </Grid>
            <Grid item md={3} xs={6}>
              Date:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "dd-MM-yyyy")}
            </Grid>
            <Grid item md={3} xs={6}>
              Time:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "h:mm aa")}
            </Grid>
            {booking.clientDate !== booking.psychologistDate ? (
              <>
                <Grid item md={3} xs={6}>
                  Client's Time:
                </Grid>
                <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                  {format(new Date(booking.clientDate ? booking.clientDate : null), "h:mm aa")}
                </Grid>
              </>
            ) : null}
            {/* <Grid item md={3} xs={6}>
              Session URL:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              <a href={booking.waitingroomurl} target="_blank" rel="noopener noreferrer">
                {booking.waitingroomurl}
              </a>
            </Grid> */}
            <hr />
            <Grid item md={12} xs={6}>
              <Form.Group>
                <Form.Label style={{ fontWeight: 600, paddingBottom: 10 }}>Why is this booking being cancelled?</Form.Label>
                <Form.Check id="cancellationType-NoShow" name="noShowCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="NoShow"
                    type="radio"
                    checked={cancellationType === "NoShow" ? true : false}
                    onChange={(e) => setCancellationType("NoShow")}
                  />
                  <Form.Check.Label style={{ marginLeft: 12 }}>Client did not attend </Form.Check.Label>
                </Form.Check>
                <Form.Check id="cancellationType-LateCancel" name="LateCancelCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="LateCancel"
                    type="radio"
                    checked={cancellationType === "LateCancel" ? true : false}
                    onChange={(e) => setCancellationType("LateCancel")}
                  />
                  <Form.Check.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Client </Form.Check.Label>
                </Form.Check>
                <Form.Check id="cancellationType-Provider24" name="providerCancellation24" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="providerCancellation24"
                    type="radio"
                    checked={cancellationType === "LateCancelProvider" ? true : false}
                    onChange={(e) => setCancellationType("LateCancelProvider")}
                  />
                  <Form.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Provider</Form.Label>
                </Form.Check>
                <Form.Check id="cancellationType-Provider" name="providerCancellation" type="radio" style={{ marginBottom: 8 }}>
                  <Form.Check.Input
                    name="providerCancellationr"
                    type="radio"
                    checked={cancellationType === "Provider" ? true : false}
                    onChange={(e) => setCancellationType("Provider")}
                  />
                  <Form.Label style={{ marginLeft: 12 }}>Cancelled</Form.Label>
                </Form.Check>
                {cancellationType !== "" ? (
                  <>
                    {cancellationType === "NoShow" ? (
                      <Form.Label style={{ marginLeft: 12 }}>To cancel please enter information relating to the Client not attending</Form.Label>
                    ) : (
                      <Form.Label style={{ marginLeft: 12 }}>To cancel please enter the reason for cancellation</Form.Label>
                    )}
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="cancellationReason"
                      value={cancellationReason}
                      onChange={(event) => setCancellationReason(event.target.value)}
                      autoComplete="new-password"
                    />
                    {cancellationType === "NoShow" ? (
                      <>
                        <Checkbox
                          aria-label="Send Cancellation SMS"
                          name="cancellationSMS"
                          value={cancellationTypeSMS}
                          onChange={(event) => updateCancellationTypeSMS(event.target.checked)}
                          style={{ paddingTop: 6, paddingLeft: 0 }}
                        />
                        <Form.Label style={{ marginLeft: 12 }}>Do you want to SMS the Client not attending</Form.Label>
                      </>
                    ) : null}
                    {cancellationTypeSMS ? (
                      <>
                        <Form.Label style={{ marginLeft: 12 }}>Please enter the SMS message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          name="cancellationTypeSMSText"
                          value={cancellationTypeSMSText}
                          onChange={(event) => setCancellationTypeSMSText(event.target.value)}
                          autoComplete="new-password"
                        />
                      </>
                    ) : null}
                  </>
                ) : null}
              </Form.Group>
            </Grid>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="new-booking-modal">
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <Button variant="secondary" size="sm" onClick={() => setShowCancelAdminBooking(false)} className="lightButtonOutlinedLarge">
                Close
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="warning"
                size="sm"
                onClick={() => cancelBooking(booking.id)}
                disabled={!cancellationReason || (cancellationReason && cancellationReason.replace(/\s/g, "").length < 5)}
                className="lightButtonOutlinedLarge"
              >
                Cancel Booking &gt;
              </Button>
            </Grid>
          </Grid>
        </Modal.Footer>
      </Modal>

      <Modal show={showToDo} onHide={() => setShowToDo(false)} dialogClassName="todos-modal-dialog">
        <Modal.Header closeButton className="todos-modal">
          <Modal.Title>To Do - {toDoTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="todos-modal">
          {toDoClientID && <ToDos clientID={toDoClientID} setShowToDo={setShowToDo} clientType={props.clienttype} />}
        </Modal.Body>
      </Modal>

      <Modal show={showSessionTypeChange} onHide={() => setShowSessionTypeChange(false)} dialogClassName="sessionTypeChange-modal modal-dialog-centered">
        <Modal.Header closeButton className="sessionTypeChange-modal-header">
          <Modal.Title>Change Session Type for Booking - {sessionTypeChangeBookingID}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            {/* {console.log(sessionTypeChangeSessionType)} */}
            <InputLabel>Select New Session Type</InputLabel>
            <Form.Control as="select" value={sessionTypeChangeSessionType} onChange={(e) => setSessionTypeChangeSessionType(e.target.value)}>
              {sessionTypeChangeProviderType === "Psychologist" ? (
                <>
                  <option value="P0101">Psychology Diagnostic Assessment & Report (One-off Appt)</option>
                  <option value="P0102">Psychology Therapy Session</option>
                  <option value="P0103">Primary Psychology case conference</option>
                  {/* <option value="P0107">Primary After hours consult</option> */}
                  <option value="S0108">Case Review Meeting (No Client) (SCC)</option>
                  {/* <option value="S0110">Secondary After hours consult</option> */}
                </>
              ) : null}
              {sessionTypeChangeProviderType === "Clinical" ? (
                <>
                  <option value="P0201">Psychology Diagnostic Assessment & Report (One-off Appt)</option>
                  <option value="P0202">Psychology Therapy Session</option>
                  <option value="P0203">Primary Psychology case conference</option>
                  {/* <option value="P0207">Primary After hours consult</option> */}
                  <option value="S0208">Case Review Meeting (No Client) (SCC)</option>
                  {/* <option value="S0210">Secondary After hours consult</option> */}
                </>
              ) : null}
              {sessionTypeChangeProviderType === "Psychiatrist" ? (
                <>
                  <option value="P0304">Primary Psychiatry Assessment and Report</option>
                  <option value="P0305">Primary Psychiatry Follow-up Review</option>
                  <option value="P0306">Primary Psychiatry Case Conference</option>
                  <option value="S0309">Secondary Psychiatry Case Conference</option>
                </>
              ) : null}
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSessionTypeChangeClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSessionTypeChange}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showBookingLocationChange}
        onHide={() => setShowBookingLocationChange(false)}
        dialogClassName="sessionTypeChange-modal modal-dialog-centered"
      >
        <Modal.Header closeButton className="sessionTypeChange-modal-header">
          <Modal.Title>Change Booking Location for Booking - {bookingLocationChangeBookingID}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <InputLabel>Select Booking Location</InputLabel>
            <Form.Control as="select" value={bookingLocationChangeBookingLocation} onChange={(e) => setBookingLocationChangeBookingLocation(e.target.value)}>
              <option value="Centre">At Centre</option>
              <option value="Remote">Remote</option>
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleBookingLocationChangeClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleBookingLocationChange}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showProvider} onHide={handleProviderClose} dialogClassName="invite-modal">
        <Modal.Header closeButton className="invite-modal">
          <Modal.Title>Available Providers</Modal.Title>
        </Modal.Header>
        <Modal.Body className="invite-modal">
          <Grid
            item
            md={12}
            style={{
              height: 710,
              width: "100%",
              overflowY: "scroll",
              paddingLeft: 20,
              backgroundColor: "rgb(255,255,255)",
            }}
          >
            {providerType !== "Supervision" ? (
              <Masonry breakpointCols={isMobile ? 1 : 3} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                {psychologistsNew &&
                  psychologistsNew.map((row, index) => {
                    return (
                      <>
                        <Card className={classes.root} variant="outlined" key={index}>
                          <CardMedia
                            className={classes.media}
                            image={`https://${storageAccountName}.blob.core.windows.net/${containerName}/${row.imageURL}`}
                            title="Psychologist"
                          />
                          <CardContent>
                            <Grid container justifyContent="space-between">
                              <Grid item sm={12}>
                                <Typography variant="h5" component="h3">
                                  {row.fullname} (Next available: {row.nextAvailableNew})
                                </Typography>
                              </Grid>
                            </Grid>
                            {providerType !== "GP" && providerType !== "Provisional" ? (
                              <>
                                {currentClientPaymentType === "Full Fee" ||
                                currentClientPaymentType === "Island" ||
                                currentClientPaymentType === "TAC" ||
                                currentClientPaymentType === "DVA" ||
                                currentClientPaymentType === "WorkCover" ? (
                                  <>
                                    <Grid container style={{ marginTop: 10 }}>
                                      <Grid item sm={6}>
                                        <Typography
                                          variant="subtitle1"
                                          style={{
                                            fontWeight: 600,
                                            marginTop: 11,
                                          }}
                                        >
                                          Out of Pocket Cost
                                        </Typography>
                                      </Grid>
                                      <Grid item sm={6} style={{ textAlign: "right" }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                          {row.hourlyRateOverrideGap && row.hourlyRateOverrideGap !== "0"
                                            ? row.hourlyRateOverrideGap
                                            : row.standardFeeOutOfPocket}
                                        </Typography>
                                      </Grid>
                                      <Grid item sm={12}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                          You pay {row.hourlyrate} on the day
                                        </Typography>
                                        <Typography>
                                          Receive back{" "}
                                          {row.hourlyRateOverrideRebate && row.hourlyRateOverrideRebate !== "0"
                                            ? row.hourlyRateOverrideRebate
                                            : row.medicareRebate}{" "}
                                          from Medicare
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </>
                                ) : null}
                                {currentClientPaymentType === "Reduced Gap" ? (
                                  <>
                                    {row.isReducedFee === "Y" ? (
                                      <>
                                        <Grid container style={{ marginTop: 10 }}>
                                          <Grid item sm={6}>
                                            <Typography
                                              variant="subtitle1"
                                              style={{
                                                fontWeight: 600,
                                                textAlign: "top",
                                              }}
                                            >
                                              Out of Pocket Cost
                                            </Typography>
                                          </Grid>
                                          <Grid item sm={6} style={{ textAlign: "right" }}>
                                            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                              {row.reducedFeeOverrideGap && row.reducedFeeOverrideGap !== "0"
                                                ? row.reducedFeeOverrideGap
                                                : row.reducedFeeOutOfPocket}
                                            </Typography>
                                          </Grid>
                                          <Grid item sm={12}>
                                            {row.reducedFee === "0" ? (
                                              <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                You pay $0 on the day
                                              </Typography>
                                            ) : (
                                              <>
                                                <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                  You pay {row.reducedFee} on the day
                                                </Typography>
                                                <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                  Receive back{" "}
                                                  {row.reducedFeeOverrideRebate && row.reducedFeeOverrideRebate !== "0"
                                                    ? row.reducedFeeOverrideRebate
                                                    : row.medicareRebate}{" "}
                                                  from Medicare
                                                </Typography>
                                              </>
                                            )}
                                          </Grid>
                                          {row.reducedFee !== "0" ? (
                                            <Grid item sm={12}>
                                              <Typography
                                                variant="subtitle2"
                                                style={{
                                                  fontWeight: 300,
                                                  fontStyle: "italic",
                                                }}
                                              >
                                                Note this provider offers some flexibility, depending on client circumstances
                                              </Typography>
                                            </Grid>
                                          ) : null}
                                        </Grid>
                                      </>
                                    ) : (
                                      <>
                                        <Grid container style={{ marginTop: 10 }}>
                                          <Grid item sm={6}>
                                            <Typography
                                              variant="subtitle1"
                                              style={{
                                                fontWeight: 600,
                                                textAlign: "top",
                                              }}
                                            >
                                              Out of Pocket Cost
                                            </Typography>
                                          </Grid>
                                          <Grid item sm={6} style={{ textAlign: "right" }}>
                                            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                              {row.reducedFeeOverrideGap && row.reducedFeeOverrideGap !== "0"
                                                ? row.reducedFeeOverrideGap
                                                : row.reducedFeeOutOfPocket}
                                            </Typography>
                                          </Grid>
                                          <Grid item sm={12}>
                                            {row.reducedFee === "0" ? (
                                              <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                You pay $0 on the day
                                              </Typography>
                                            ) : (
                                              <>
                                                <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                  You pay {row.reducedFee} on the day
                                                </Typography>
                                                <Typography variant="subtitle1" style={{ fontWeight: 300 }}>
                                                  Receive back{" "}
                                                  {row.reducedFeeOverrideRebate && row.reducedFeeOverrideRebate !== "0"
                                                    ? row.reducedFeeOverrideRebate
                                                    : row.medicareRebate}{" "}
                                                  from Medicare
                                                </Typography>
                                              </>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </>
                                    )}
                                  </>
                                ) : null}
                                <Grid container style={{ marginBottom: 15, marginTop: 10 }}>
                                  {row.areasOfInterest.map((row) => {
                                    return <Chip size="small" key={row} variant="outlined" label={row} style={{ margin: 2 }} />;
                                  })}
                                </Grid>
                              </>
                            ) : null}
                            <Typography className={classes.pos} color="textSecondary">
                              <br />
                            </Typography>
                            <Grid container>
                              <Typography variant="body2" component="p">
                                <Interweave content={row.bio.substring(0, 700)} />
                                {row.bio.length > 700 ? (
                                  <>
                                    ...
                                    <Badge
                                      variant="secondary"
                                      onClick={() => moreProviderBio(row.fullname, row.bio)}
                                      style={{
                                        marginRight: 5,
                                        cursor: "pointer",
                                      }}
                                    >
                                      more
                                    </Badge>
                                  </>
                                ) : null}
                              </Typography>
                            </Grid>
                            <br />
                          </CardContent>
                          <CardActions disableSpacing>
                            {currentClientPaymentType === "Bulk Billed" && row.bulkBillingAvailable === "0" ? (
                              <Button variant="secondary">Not Available to Bulk Bill</Button>
                            ) : (
                              <Button onClick={() => selectProvider(row)}>Select and Book</Button>
                            )}
                            <IconButton
                              className={clsx(classes.expand, {
                                [classes.expandOpen]: expanded,
                              })}
                              onClick={() => handleExpandClick(row.id)}
                              aria-expanded={expanded}
                              aria-label="show more"
                            >
                              <ExpandMoreIcon />
                            </IconButton>
                          </CardActions>
                          <Collapse in={expanded !== row.id} timeout="auto" unmountOnExit>
                            <CardContent>
                              <Typography variant="body2" component="div">
                                {row.therapyTypes &&
                                  row.therapyTypes.map((row) => {
                                    return <Chip size="small" key={row} variant="outlined" label={row} style={{ margin: 2 }} />;
                                  })}
                              </Typography>
                            </CardContent>
                          </Collapse>
                        </Card>
                      </>
                    );
                  })}
              </Masonry>
            ) : (
              <Masonry breakpointCols={isMobile ? 1 : 3} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
                {psychologistsSupervision &&
                  psychologistsSupervision.map((row, index) => {
                    return (
                      <>
                        <Card className={classes.root} variant="outlined" key={index}>
                          <CardMedia
                            className={classes.media}
                            image={`https://${storageAccountName}.blob.core.windows.net/${containerName}/${row.imageURL}`}
                            title="Psychologist"
                          />
                          <CardContent>
                            <Grid container justifyContent="space-between">
                              <Grid item sm={12}>
                                <Typography variant="h5" component="h3">
                                  {row.fullname} (Next available: {row.nextAvailableSupervision})
                                </Typography>
                              </Grid>
                            </Grid>
                            <Grid container style={{ marginTop: 10 }}>
                              <Grid item sm={8}>
                                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                  Cost
                                </Typography>
                              </Grid>
                              <Grid item sm={4} style={{ textAlign: "right" }}>
                                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                  {row.supervisorHourlyRate}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Typography className={classes.pos} color="textSecondary">
                              <br />
                            </Typography>
                            <Grid container>
                              <Typography variant="body2" component="p">
                                <Interweave content={row.supervisorBio.substring(0, 700)} />
                                {row.supervisorBio.length > 700 ? (
                                  <>
                                    ...
                                    <Badge
                                      variant="secondary"
                                      onClick={() => moreProviderBio(row.fullname, row.supervisorBio)}
                                      style={{
                                        marginRight: 5,
                                        cursor: "pointer",
                                      }}
                                    >
                                      more
                                    </Badge>
                                  </>
                                ) : null}
                              </Typography>
                            </Grid>
                            <br />
                          </CardContent>
                          <CardActions disableSpacing>
                            <Button onClick={() => selectProvider(row)}>Select and Book</Button>
                          </CardActions>
                          <CardContent>
                            <Typography variant="h6" component="h3">
                              Available For
                            </Typography>
                            <Row>
                              <List className={classes.root}>
                                {supervisionAreas.map((sRow) => {
                                  const labelId = `checkbox-list-label-${sRow.id}`;
                                  var isChecked = row.supervisorAreas.includes(sRow.id);
                                  return (
                                    <ListItem key={sRow.id} role={undefined} dense button>
                                      <ListItemIcon style={{ minWidth: 40 }}>
                                        <Checkbox
                                          edge="start"
                                          checked={isChecked}
                                          tabIndex={-1}
                                          disableRipple
                                          inputProps={{
                                            "aria-labelledby": labelId,
                                          }}
                                        />
                                      </ListItemIcon>
                                      <ListItemText
                                        id={labelId}
                                        style={{ fontSize: 12 }}
                                        disableTypography
                                        primary={<Typography className={isChecked ? classes.linkSelected : classes.link}>{sRow.issue}</Typography>}
                                        className={classes.link}
                                      />
                                    </ListItem>
                                  );
                                })}
                              </List>
                            </Row>
                            <Typography variant="h6" component="h3" style={{ paddingTop: 20 }}>
                              Endorsed In
                            </Typography>
                            <Row>
                              <Col md="6">
                                <List className={classes.root}>
                                  {endorsedSupervisionAreas.map((sRow) => {
                                    var isChecked = row.supervisorAreas.includes(sRow.id);
                                    const labelId = `checkbox-list-label-${sRow.id}`;
                                    if (isChecked) {
                                      return (
                                        <ListItem key={sRow.id} role={undefined} dense button>
                                          <ListItemIcon style={{ minWidth: 40 }}>
                                            <Checkbox
                                              edge="start"
                                              checked={isChecked}
                                              tabIndex={-1}
                                              disableRipple
                                              inputProps={{
                                                "aria-labelledby": labelId,
                                              }}
                                            />
                                          </ListItemIcon>
                                          <ListItemText
                                            id={labelId}
                                            style={{ fontSize: 12 }}
                                            disableTypography
                                            primary={<Typography className={isChecked ? classes.linkSelected : classes.link}>{sRow.issue}</Typography>}
                                            className={classes.link}
                                          />
                                        </ListItem>
                                      );
                                    } else {
                                      return null;
                                    }
                                  })}
                                </List>
                              </Col>
                            </Row>
                          </CardContent>
                        </Card>
                      </>
                    );
                  })}
              </Masonry>
            )}
          </Grid>
        </Modal.Body>
        <Modal.Footer className="invite-modal">
          <Button variant="secondary" onClick={handleProviderClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showProviderBio} onHide={() => setShowProviderBio(false)} dialogClassName="invite-modal">
        <Modal.Header closeButton className="invite-modal">
          <Modal.Title>{providerBioFullName}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="invite-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          <Grid container>
            <Typography variant="body2" component="p">
              <Interweave content={providerBioBio} />
            </Typography>
          </Grid>
        </Modal.Body>
        <Modal.Footer className="invite-modal">
          <Button variant="secondary" onClick={() => setShowProviderBio(false)} className="lightButtonOutlinedLarge">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
